import {SET_AI_SESSION} from '../actions/types';


const aiSession = (state = {}, action) => {
  switch (action.type) {
    case SET_AI_SESSION:
      return action.payload;
    default:
      return state;
  }
};

export default aiSession;